import { useAuthStore } from '@/stores/authStore'

/** true quando bootstrap terminou e há sessão utilizável (Bearer ou cookie httpOnly) */
export function useApiSessionReady(): boolean {
  return useAuthStore(
    (s) => s.authReady && (Boolean(s.token) || (s.isAuthenticated && s.sessionUsesCookie)),
  )
}
